import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatProgressBar } from '@angular/material/progress-bar'
import {
  phoneTransform,
  responseDefaultForm,
} from '../../../shared/utils/utils'
import { TelefonePipe } from '../../../shared/pipes/phone.pipes'
import { ResponsibleClientEditFormComponent } from './responsible-client-form/responsible-client-edit-form.component'
import { ResponsibleService } from '../../../core/services/person/responsible/responsible.service'

@Component({
  selector: 'responsible-client-edit',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    MatProgressBar,
    TelefonePipe,
    ResponsibleClientEditFormComponent,
  ],
  templateUrl: './responsible-client-edit.component.html',
  styleUrl: './responsible-client-edit.component.scss',
  providers: [ResponsibleService],
  standalone: true,
})
export class ResponsibleClientEditComponent implements OnInit, AfterViewInit {
  constructor(
    private responsibleService: ResponsibleService,
    private snackbar: SnackbarCustomService,
  ) {}

  item: any = {}
  loading = true

  @Output() response = new EventEmitter<any>()
  @Input() idPerson = 0
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'name',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'email',
      key: 'email',
      description: 'Email',
    },
    {
      keyColumn: 'phone',
      key: 'telefone',
      description: 'Telefone',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]

  page = 1
  rows = 10
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = ['name', 'email', 'phone', 'action']

  inputSearchConsultant: any = { type: '', search: '' }
  listSearch: any = [
    { id: 'nome', description: 'Nome', type: 'string', visible: true },
    { id: 'email', description: 'Email', type: 'string', visible: true },
    { id: 'telefone', description: 'Telefone', type: 'string', visible: true },
  ]
  searchForm: any = { search: false, model: {} }

  ngOnInit(): void {
    this.getConsultantByPerson()
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    // if (this.table) {
    //   this.table.renderRows()
    // }
  }

  pageChanged($event: any) {
    this.page = $event.pageIndex + 1
    // this.rows = $event.pageSize
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchConsultant()
    } else {
      this.getConsultantByPerson()
    }
  }

  getConsultantByPerson() {
    this.loading = true
    this.responsibleService
      .listPagedResponsibleByPerson(this.idPerson, this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchConsultant() {
    this.loading = true
    this.responsibleService
      .searchPagedResponsible(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
          telefone_transform: phoneTransform(item.telefone),
        })
      }
    }
    this.tableSource = new MatTableDataSource<any>(list)
    this.refreshTable()
  }

  responseForm(response: any): void {
    if (response.refresh) {
      this.uploadList()
    }
    if (response.clear) {
      this.clearItem()
    }
  }

  updateItem(element: any) {
    this.item = { edit: true, data: element }
  }

  deleteItem(element: any) {
    this.clearItem()
    this.responsibleService.deleteResponsible({ id: element.id }).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  clearItem() {
    this.item = {}
  }

  createModel(element: any) {
    const model: any = { idPerson: this.idPerson }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }
}
